export const CONNECTED_WALLET_ICON = '/img/icons/wallet.svg#icon';
// export const DISCONNECTED_WALLET_ICON = '/icons/disconnectedWallet.svg#icon';

export const REFRESH = '/img/icons/modal/refresh.svg#icon';
export const HIDE = '/img/icons/modal/hide.svg#icon';
export const SHOW = '/img/icons/modal/show.svg#icon';

export const STATUS_GREEM = '/img/icons/status/green.svg';

export const ADA = '/img/tokens/ada.png';
export const GENERIC = '/img/tokens/generic.png';

export const WALLET = 'public/img/icons/wallet.svg';
